import { Popover } from "@headlessui/react";
import React, { useContext, useEffect, useState } from "react";
import Navbar from "../components/navbar";
import BackButton from "../components/back_button";
import { AuthContext } from "../contexts/auth"
import { months, years } from "../config";
import { fetchEmployee, uploadBustePagaSingolo } from "../services/api";
import Fetching from '../components/fetching';

import {
  useParams,
} from "wouter";
import UploadForm from "../components/upload_form";

export default function UploadSingleBusta() {
  
  const { codiceFiscale } = useParams();
  const { profile, token } = useContext(AuthContext)

  const [fetching, setFetching] = useState(true)
  const [employee, setEmployee] = useState(null)

  useEffect(() => {
    if (token && !fetching) {
      console.log(token)
      setFetching(true)
    }
    fetchEmployee(token, codiceFiscale)
      .then((res) => {
        setEmployee(res)
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])


  return (
    <><div className="min-h-full">
     
      <main className="mt-10 pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* back button */}
          <div className="flex items-center my-4">
            {
              employee ? <BackButton prevLocation={`/dipendenti/${employee.cf}`} /> : <BackButton prevLocation={`/dipendenti`} />
            }
          </div>
          {/* a div with a fake table */}
          <div className="">
            {fetching && (
              <Fetching />
            )}

            {(!fetching && employee) && (
              <>
              <div className="bg-white px-6 py-12 sm:py-12 lg:px-8 mb-10">
                <div className="mx-auto max-w-2xl text-center">
                  <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                    Carica una busta paga per {employee.first_name} {employee.last_name}
                    <br />
                    <small>
                      {employee.cf}
                    </small>
                  </h2>
                  <p className="mt-6 text-lg leading-8 text-gray-600">
                    {
                      employee.email
                    }
                  </p>
                </div>
              </div>
                <div className="bg-white rounded-lg shadow overflow-hidden p-6">
            <UploadForm
              enableUpload={true}
              fields={
                [
                  { name: 'year', label: 'Anno', type: 'select', options: years },
                  { name: 'month', label: 'Mese', type: 'select', options: months },
                  { name: 'net_amount', label: 'Importo Netto', type: 'float'},
                  {
                    name: 'notify_employee', label: 'Notifica il dipendente via email', type: 'checkbox', options: [
                      { label: 'Si', value: true },
                    ],
                  },
                  { type: 'hidden', name: 'anagrafica_create_missing', value: 'true' },
                  { type: 'hidden', name: 'typology', value: 'bp' },
                  { type: 'hidden', name: 'employee_id', value: employee.employee.id },
                ]
              }
              formType="BustePagasingola"
              submitLabel="Carica"
                    submitAction={uploadBustePagaSingolo}
            />
                </div></>)}
          </div>
        </div>
      </main>
    </div>
    </>
  )
}